<div class="header flex justify-content-end gap-2">
  <div class="totalprice">
    Precio:
    <span
      >{{ (product!.price + (product!.extraPrice || 0)).toFixed(2) }} €</span
    >
  </div>

  <p-button label="Cancelar" severity="secondary" (onClick)="closeDialog()" />

  <p-button label="Añadir al carrito" (onClick)="addToCart()" />
</div>
<p-divider></p-divider>

<div class="body flex flex-column">
  <form>
    <div *ngFor="let ingredient of items" class="ingredient-item">
      <div class="image">
        <img src="{{ ingredient.image_url }}" alt="{{ ingredient.name }}" />
      </div>
      <div class="data">
        <div>
          <b>{{ ingredient.name }}</b>
        </div>
        <div>Extra {{ ingredient.price.toFixed(2) || 0 }} €</div>
      </div>

      <div class="actions">
        <app-quantity-counter
          [initialQuantity]="ingredient.initialQuantity || 0"
          [min]="0"
          [max]="2"
          (newQuantity)="
            calculateExtraAmount(ingredient, $event);
            calculatePrice();
            updateFinalIngredients(ingredient.productIngredientId, $event)
          "></app-quantity-counter>

        <div>{{ ingredient.totalPrice!.toFixed(2) }} €</div>
      </div>
    </div>
  </form>
</div>
